import { useRequest } from 'utils/useFetch';

import request from '../../../utils/useAxios';
import {
  UUCAFE_PRODUCT_ADD_FAIL,
  UUCAFE_PRODUCT_ADD_REQUEST,
  UUCAFE_PRODUCT_ADD_SUCCESS,
  UUCAFE_PRODUCT_FAIL,
  UUCAFE_PRODUCT_REQUEST,
  UUCAFE_PRODUCT_SUCCESS,
  UUCAFE_PRODUCT_UPDATE_FAIL,
  UUCAFE_PRODUCT_UPDATE_REQUEST,
  UUCAFE_PRODUCT_UPDATE_SUCCESS,
  UUCAFE_PRODUCT_LIST_FAIL,
  UUCAFE_PRODUCT_LIST_REQUEST,
  UUCAFE_PRODUCT_LIST_SUCCESS,
} from '../../constants/data/uuCafeProductConstants';

/*
* @Params
* {
  "page": 0,
  "page_size": 0,
  "type": 0,
  "order": "string",
  "order_by": "string",
  "keyword": "string",
  "menuId": 0,
  "status": 0
  }
*
*/
export const getCafeProductList = data => {
  return async (dispatch, getState) => {
    await useRequest({
      data,
      dispatch,
      failConstant: UUCAFE_PRODUCT_LIST_FAIL,
      method: 'post',
      requestConstant: UUCAFE_PRODUCT_LIST_REQUEST,
      successConstant: UUCAFE_PRODUCT_LIST_SUCCESS,
      url: '/Backend/Cafe_MealCoffeePrd/list',
    });
  };
};

export const getCafeProductDetail = params => {
  return async (dispatch, getState) => {
    await useRequest({
      dispatch,
      failConstant: UUCAFE_PRODUCT_FAIL,
      method: 'get',
      requestConstant: UUCAFE_PRODUCT_REQUEST,
      successConstant: UUCAFE_PRODUCT_SUCCESS,
      url: `/Backend/Cafe_MealCoffeePrd/prd/${params.id}`,
    });
  };
};

/*
* @Params
id integer($int32)
menuId integer($int32)
name string
name_en string
content string
content_en string
status integer($int32)
img_files array
temperatures string
prices string
*/
export const addCafeProductDetail = data => {
  return async (dispatch, getState) => {
    await useRequest({
      data,
      dispatch,
      failConstant: UUCAFE_PRODUCT_ADD_FAIL,
      method: 'post',
      requestConstant: UUCAFE_PRODUCT_ADD_REQUEST,
      successConstant: UUCAFE_PRODUCT_ADD_SUCCESS,
      url: '/Backend/Cafe_MealCoffeePrd/prd/add',
    });
  };
};

/*
* @Params
id integer($int32)
menuId integer($int32)
name string
name_en string
content string
content_en string
status integer($int32)
img_files array
temperatures string
prices string
*/

export const updateCafeProductDetail = data => {
  return async (dispatch, getState) => {
    await useRequest({
      data,
      dispatch,
      failConstant: UUCAFE_PRODUCT_UPDATE_FAIL,
      method: 'post',
      requestConstant: UUCAFE_PRODUCT_UPDATE_REQUEST,
      successConstant: UUCAFE_PRODUCT_UPDATE_SUCCESS,
      url: '/Backend/Cafe_MealCoffeePrd/prd/update',
    });
  };
};

/*
  @params
  data:
  id: integer($int32)
*/
export const deleteCafeProductDetail = async (params) => {
  return await request({
    method: 'get',
    params,
    url: '/Backend/Cafe_MealCoffeePrd/prd/delete',
  });
};
